import { render, staticRenderFns } from "./simulation.vue?vue&type=template&id=07e2deea&"
import script from "./simulation.vue?vue&type=script&lang=js&"
export * from "./simulation.vue?vue&type=script&lang=js&"
import style0 from "./simulation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports